import { render, staticRenderFns } from "./DataCardSearchField.vue?vue&type=template&id=d8a8b3c4&"
import script from "./DataCardSearchField.vue?vue&type=script&lang=js&"
export * from "./DataCardSearchField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
